var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 14.5003C23.5529 14.5023 23.275 14.5549 23.0132 14.6555L20.2155 12.3653C20.2843 12.1157 20.3333 11.8567 20.3333 11.5837C20.3333 9.96666 19.0337 8.66699 17.4167 8.66699C15.7997 8.66699 14.5 9.96666 14.5 11.5837C14.5 12.0457 14.6167 12.4762 14.8057 12.8635L11.4118 16.8745C11.276 16.8491 11.1382 16.8354 11 16.8337C10.7912 16.8337 10.594 16.8687 10.4027 16.92L7.41251 13.9298C7.46501 13.7397 7.50001 13.5425 7.50001 13.3337C7.50001 12.041 6.45934 11.0003 5.16668 11.0003C3.87401 11.0003 2.83334 12.041 2.83334 13.3337C2.83334 14.6263 3.87401 15.667 5.16668 15.667C5.37551 15.667 5.57268 15.632 5.76401 15.5807L8.75418 18.5708C8.6981 18.7647 8.66866 18.9652 8.66668 19.167C8.66668 20.4597 9.70734 21.5003 11 21.5003C12.2927 21.5003 13.3333 20.4597 13.3333 19.167C13.3333 18.8905 13.2773 18.6303 13.1898 18.3842L16.5883 14.3685C16.8532 14.4455 17.1273 14.5003 17.4167 14.5003C17.8771 14.4978 18.3303 14.3854 18.7385 14.1725L21.5373 16.4627C21.5154 16.5852 21.5029 16.7092 21.5 16.8337C21.5 18.1263 22.5407 19.167 23.8333 19.167C25.126 19.167 26.1667 18.1263 26.1667 16.8337C26.1667 15.541 25.126 14.5003 23.8333 14.5003Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.0dda7d8d6e9aeeeaeee6dd6f0e923437.svg";
export { ForwardRef as ReactComponent };